import React, { useEffect } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { PageHeader, Button, Card, Row, Col } from "antd";
import { reverse } from "named-urls";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { sliceKey, reducer, actions } from "./slice";
import { viewLogisticSaga } from "./saga";
import * as selectors from "./selectors";
import { addressToStringMultiLine } from "../../../../utils/formatter";
import routes from "../../../../../routes";
import Loader from "../../../../components/Loader";
import { useAuth } from "../../../../contexts/auth";
const AddressCard = ({ title, address, options }) => {
  return (
    <Card
      title={title}
      style={{ width: 300, marginBottom: 30 }}
      //Can be implemented for future options
      /*  <EditOutlined key="edit" onClick={() => setShowForm(true)} />,
        <DeleteOutlined key="delete" />, */
    >
      <div style={{ minHeight: 120 }}>{addressToStringMultiLine(address)}</div>
    </Card>
  );
};

const ViewLogisticsPartner = () => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: viewLogisticSaga });
  const dispatch = useDispatch();
  const { logisticId } = useParams();
  const history = useHistory();
 const auth = useAuth();
  const user = auth.loggedInUser;

  const userRole = user?.role;
  useEffect(() => {
    dispatch(actions.fetchLogisticDetails({ id: logisticId }));
  }, [dispatch, logisticId]);

  const logisticData = useSelector(selectors.selectLogisticDetails) || {};

  const loading = useSelector(selectors.selectLoading);

  const showLoader = loading;
  const handleBack = () => {
    history.push(routes.backOffice.logisticPartners.list);
  };

  return (
    <div style={{ height: "100%" }}>
      <PageHeader
        ghost={false}
        title="Logistic Details"
        onBack={handleBack}
        subTitle={logisticData.name}
        extra={[
              userRole !== "csc_admin" && (
                <Button key="1" type="primary">
                  <Link
                    to={reverse(`${routes.backOffice.logisticPartners.details.edit}`, {
                      logisticId,
                    })}
                  >
                    Edit
                  </Link>
                </Button>
              ),
            ]}
      />
      {showLoader ? (
        <Loader />
      ) : (
        <div
          style={{
            height: "calc(100vh - 137px)",
            overflowY: "auto",
            padding: 24,
          }}
        >
          <div
            style={{ backgroundColor: "#fff", padding: 20, marginBottom: 30 }}
          >
            <div style={{}}>
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  justifyContent: "space-between",
                }}
              >
                <p>
                  <strong>Logistic Name:</strong> {logisticData.name}
                </p>
                <p>
                  <strong>PoC Name:</strong> {logisticData.pocName}
                </p>
                <p>
                  <strong>PoC Contact:</strong> {logisticData.pocContact}
                </p>
              </div>
              <div>
                <p>
                  <strong>Remarks:</strong> {logisticData.remarks}
                </p>
              </div>
            </div>
          </div>
          <div style={{ marginBottom: 10 }}>
            <h1>Addresses</h1>
            <Row gutter={32}>
              {logisticData?.address ? (
                <Col>
                  <AddressCard
                    title="Registered Address"
                    address={logisticData?.address}
                  />
                </Col>
              ) : (
                ""
              )}
            </Row>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewLogisticsPartner;
